import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import './Modal.css';
import { modalOpen, modalClose } from '../../actions/ModalActions';

if (typeof window !== 'undefined') {
  ReactModal.setAppElement('#root');
}

class Modal extends Component {
  handleOpenModal = () => {
    document.body.style.paddingRight =
      window.innerWidth - document.body.offsetWidth + 'px';
    this.props.modalOpen();
  };

  handleCloseModal = () => {
    document.body.style.paddingRight = 0;
    this.props.modalClose();
  };

  render() {
    const { label, modal: { opened }, className, children } = this.props;

    return (
      <React.Fragment>
        <span
          key='modalButton'
          className={className}
          onClick={this.handleOpenModal}>
          {this.props.button}
        </span>
        <ReactModal
          key='modal'
          className='modal'
          overlayClassName='modalOverlay'
          isOpen={opened}
          contentLabel={label}
          onRequestClose={this.handleCloseModal}>
          <button className='modal__close' onClick={this.handleCloseModal}>
            Закрыть
          </button>
          <div className='modal__inner'>{children}</div>
        </ReactModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ modalOpen, modalClose }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Modal));



// WEBPACK FOOTER //
// ./src/components/Modal/index.js